import { Vector3 } from 'three';

export class PMath {
  public static getVectorProjectionInXY(v1: Vector3, v2: Vector3 = null): Vector3 {
    if (!v2) {
      return new Vector3(v1.x, v1.y, 0).normalize();
    }
    return new Vector3(v1.x - v2.x, v1.y - v2.y, 0).normalize();
  }

  public static azimuthDegToRotationRad(azimuth: number): number {
    return (Math.PI / 180) * (90 - azimuth);
  }
}
